module.exports = __webpack_public_path__ + "static/media/emoji-pensive-face.e6144479.png";